export const COOKIES = {
  RISKIFIED_TOKEN: 'riskifiedToken',
} as const;
